import crudMixin from '@/services/crudMixin';
import api from '@/api';
import { crudRead, crudCreate } from '@/api/crud';
import { getOid } from './utils';

export default {
  mixins: [crudMixin],
  props: {
    id: {},
    /**
     * if no data provided, will fetch from crudURL with the id specified.
     * if data specified, all api operations will be disabled and instead only emit events.
     */
    data: {},
  },
  data() {
    return {
      model: {},
      populate: null,
      isEditFormLoading: false,
    };
  },
  computed: {
    isCreate() {
      if (this.id && this.id !== 'new') return false;
      if (this.data?._id || this.data?.id) return false;
      return true;
    },
    idAndData() {
      return { id: this.id, data: this.data };
    },
    crudURL() {
      return '_';
    },
  },
  watch: {
    // id() {
    //   this.reload();
    // },
    // data() {
    //   this.reload();
    // },
    idAndData: {
      handler(newValue, oldValue) {
        this.reload();
      },
      immediate: true,
    },
  },
  // created() {
  //   this.model = this.defaultData();
  // },
  async beforeMount() {
    //this.model = await this.defaultData();
  },
  methods: {
    async reload() {
      // placeholder to prevent null reference
      this.isEditFormLoading = true;
      try {
        if (this.data?.id || this.data?._id) {
          this.model = this.data;
        } else if (this.id && this.id !== 'new') {
          this.model = await this.readDataById(this.id);
        } else {
          this.model = await this.defaultData();
          if (this.data) {
            // data without id ,  regarded as default value
            Object.assign(this.model, this.data);
          }
        }
        this.$refs.form?.reset?.();
      } finally {
        this.isEditFormLoading = false;
      }
    },
    async readDataById(id) {
      try {
        return await crudRead(api, this.crudURL, id, { populate: this.populate });
      } catch (error) {
        return null;
      }
    },
    async defaultData() {
      // placeholder to prevent null reference
      return this.model;
    },
    async afterCreated(model) {
      this.$emit('create', model);
    },
    async afterUpdated(model) {
      this.$emit('update', model);
    },
    async beforeCreate(model) {
      this.$emit('beforeCreate', model);
    },
    async beforeUpdate(model) {
      this.$emit('beforeUpdate', model);
    },
    async promptCreate(model = this.model) {
      if (!(await this.$refs.form.validate())) {
        return;
      }
      await this.beforeCreate(model);
      try {
        const _model = await crudCreate(api, this.crudURL, model);
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Created',
          type: 'success',
          color: 'success',
        });
        this.afterCreated(_model);
        return _model;
      } catch (err) {
        this.handleError(err);
      }
    },
    async promptUpdate(patch = this.model, id = this.id || this.data?._id) {
      if (!patch && !(await this.$refs.form?.validate?.())) {
        return;
      }
      await this.beforeUpdate(patch);
      return crudMixin.methods.promptUpdate.call(this, patch, id);
    },
    async doUpdate(patch, id) {
      let x;
      if (this.data) {
        if (patch) {
          Object.assign(this.model, patch);
        }
        //x = this.model;
        x = (await api.patch(this.crudURL + '/' + id, patch)).data;
      } else {
        x = (await api.patch(this.crudURL + '/' + id, patch)).data;
        //x = await crudMixin.methods.doUpdate.call(this, patch, this.id);
      }
      await this.afterUpdated(x);
      return x;
    },
    async promptDelete(id = this.id) {
      if (this.data) {
        return this.doDelete(id);
      } else {
        return crudMixin.methods.promptDelete.call(this, id);
      }
    },
    async doDelete(id) {
      let x;
      if (this.data) {
        x = true;
      } else {
        x = await crudMixin.methods.doDelete.call(this, id);
      }
      this.$emit('delete', this.model);
      return x;
    },
  },
};
